import { useGetPayseraPaymentMethodsLazyQuery } from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useGetBanks = () => {
  const [requestBanklinks, { data, loading, error }] =
    useGetPayseraPaymentMethodsLazyQuery({
      context: { apiVersion: AppApiVersions.core },
    });

  const getBanklinks = (language_abbr: string) => {
    requestBanklinks({ variables: { language_abbr } });
  };

  return {
    getBanklinks,
    banklinks: data?.paymentMethods ?? [],
    banklinksLoading: loading,
    banklinksError: error,
  };
};
